// @TODO: this file should be split into compnent folders with each type of widget...maybe _some_ of these are shared, but not most of them
/**
 * Ryan O'Dowd
 * 2024-02-17
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({safeAreaInsets}) => {
  return {
    container: {
      marginTop: 8,
    },
    hidden: {
      display: 'none',
    },
    mainListContainer: {
      flexGrow: 1,
      paddingBottom: safeAreaInsets.bottom,
    },
  };
};

export default getStyles;
